import { Component, OnInit, ViewChild } from "@angular/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { NzTableQueryParams } from "ng-zorro-antd/table";
import { taskSubtaskMaster } from "src/app/Models/BasicForms/taskSubtaskMaster";
import { ApiService } from "src/app/Service/api.service";
import { AttachmentMasterComponent } from "../../AttachmentM/attachment-master/attachment-master.component";
import { CommentComponent } from "../../Comment/comment/comment.component";
import { WorklogComponent } from "../../workLog/worklog/worklog.component";
import { TaskDrawerComponent } from "../task-drawer/task-drawer.component";
import { TaskSubtaskMappingComponent } from "../task-subtask-mapping/task-subtask-mapping.component";

@Component({
  selector: "app-task-master",
  templateUrl: "./task-master.component.html",
  styleUrls: ["./task-master.component.css"],
})
export class TaskMasterComponent implements OnInit {
  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService
  ) {}
  moduleID = 0;
  moduleList = [];
  formTitle = "Tasks/ Subtasks";
  categoryID: any;
  categoryList = [];
  ngOnInit(): void {
    this.filterIsAppliedOrNot();
    this.loadAllProjects();
    this.logtext = "OPENED - Task Master form KEYWORD[O - Task Master] ";
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });
  }

  roadmaptrue=false
  projectList = [];
  projectID = 0;
  loadAllProjects() {
    this._apiService.getAllProjects(0, 0, "ID", "desc", "").subscribe(
      (projectData) => {
        this.projectList = projectData["data"];
      },
      (err) => {}
    );
  }
  getModules(event) {
    this.projectID = event;
    this._apiService
      .getAllModules(0, 0, "ID", "desc", " AND PROJECT_ID=" + this.projectID)
      .subscribe(
        (dta) => {
          this.moduleList = dta["data"];
        },
        (err) => {}
      );
  }

  clientID = [];
  clientList = [];

  loadAllClients() {
    this._apiService
      .getAllClients(0, 0, "ID", "desc", " and IS_ACTIVE=1")
      .subscribe(
        (clientData) => {
          this.clientList = clientData["data"];
        },
        (err) => {}
      );
  }

  displayFilterBox = false;
  flterBoxVisibleInvisible() {
    this.displayFilterBox = !this.displayFilterBox;
  }

  filterButtonType = "default";
  filterIsAppliedOrNot() {
    // if (this.clientID.length > 0) {
    //
    //   this.filterButtonType= "primary";
    // } else {
    //   this.filterButtonType= "default";
    // }
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [
    ["TASK_CATEGORY_NAME", "Category"],
    ["NAME", "Task/ Subtask"],
    ["DESCRIPTION", "Description"],
  ];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  taskSubtaskData: [];

  getAllTaskSubtask(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;

    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext =
        'Filter Applied - Task Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Task Master] ';
      this._apiService
        .addLog("A", this.logtext, this._apiService.emailId)
        .subscribe((successCode) => {
          if (successCode["code"] == "200") {
          } else {
          }
        });
    } catch (error) {
      sort = "";
    }

    if (this.searchText != "") {
      var likeQuery = " AND (";
      this.columns.forEach((column) => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2) + ")";
    }

    this.logtext =
      'Filter Applied - Task Master form "+ likeQuery +" KEYWORD [F - Task Master] ';
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });

    var filter = "";
    if (likeQuery) filter = this.filterQuery + likeQuery;
    else filter = this.filterQuery;

    this.isloadSpinning = true;

    this._apiService
      .getAllTaskSubtask(
        this.pageIndex,
        this.pageSize,
        this.sortKey,
        sort,
        filter
      )
      .subscribe(
        (data) => {
          this.loadingRecords = false;
          this.totalRecords = data["count"];
          this.taskSubtaskData = data["data"];
        },
        (err) => {
          if (err["ok"] == false)
            this.notificationService.error("Server Not Found", "");
        }
      );
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";

  applyFilter() {
    this.filterQuery = "";

    if (this.projectID != 0) {
      this.filterQuery += " AND PROJECT_ID = " + this.projectID;
     
    }

    if (this.moduleID != 0) {
      this.filterQuery += " AND MODULE_ID = " + this.moduleID; 
    }
    this.isFilterApplied = "primary";
    this.filterClass = "filter-invisible"; 
    this.getAllTaskSubtask(true);
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.clientID = [];

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.getAllTaskSubtask();
  }

  drawerVisible = false;
  mappingDrawerVisible = false;
  worklogDrawerVisible = false;
  commentDrawerVisible = false;
  taskTransferHistoryDrawerVisible = false;
  attachmentDrawerVisible = false;

  drawerTitle = "";
  mappingDrawerTitle = "";
  worklogDrawerTitle = "";
  commentDrawerTitle = "";
  taskTransferHistoryDrawerTitle = "";
  attachmentDrawerTitle = "";

  taskSubtaskDrawerData: taskSubtaskMaster = new taskSubtaskMaster();
  showWorkLogsLink = false;

  add() {
    this.drawerVisible = true;
    this.drawerTitle = "Create Task/ Subtask";
    this.taskSubtaskDrawerData = new taskSubtaskMaster();
    this.showWorkLogsLink = false;
    this.taskSubtaskDrawerData.IS_ACTIVE = true;

    this.logtext = "ADD - Task Master form KEYWORD [A - Task Master] ";
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });
  }

  @ViewChild(TaskDrawerComponent) TaskDrawerComponentVar: TaskDrawerComponent;

  edit(data: taskSubtaskMaster) {
    this.drawerVisible = true;
    this.drawerTitle = "Task/ Subtask Details";
    this.taskSubtaskDrawerData = Object.assign({}, data);
    this.showWorkLogsLink = true;

    this.TaskDrawerComponentVar.showTags(data.TAGS);

    this.logtext = "EDIT - Task Master form KEYWORD [E - Task Master] ";
    this._apiService
      .addLog("A", this.logtext, this._apiService.emailId)
      .subscribe((successCode) => {
        if (successCode["code"] == "200") {
        } else {
        }
      });
  }

  drawerClose() {
    this.getAllTaskSubtask();
    this.drawerVisible = false;
    this.showWorkLogsLink = null;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  mappingDrawerClose() {
    this.mappingDrawerVisible = false;
  }

  get callBackMappingDrawerClose() {
    return this.mappingDrawerClose.bind(this);
  }

  taskMappingDrawerData: [];
  @ViewChild(TaskSubtaskMappingComponent)
  TaskSubtaskMappingComponentVar: TaskSubtaskMappingComponent;

  mapTaskSubtask(data: taskSubtaskMaster) {
    // this.TaskSubtaskMappingComponentVar.loadingRecords = true;

    this._apiService
      .getTaskSubtaskDetails(data.ID, data.TASK_CATEGORY_ID)
      .subscribe(
        (data) => {
          // this.TaskSubtaskMappingComponentVar.loadingRecords = false;

          this.taskMappingDrawerData = data["data"];
        },
        (err) => {}
      );
    this.mappingDrawerVisible = true;
    this.taskSubtaskDrawerData = Object.assign({}, data);
    this.mappingDrawerTitle = data.NAME;

    this.TaskSubtaskMappingComponentVar.TASK_CATEGORY_ID =
      data.TASK_CATEGORY_ID;
  }

  worklogDrawerClose() {
    this.worklogDrawerVisible = false;
  }

  get callBackWorklogDrawerClose() {
    return this.worklogDrawerClose.bind(this);
  }

  type: number;
  @ViewChild(WorklogComponent) WorklogComponentVar: WorklogComponent;

  worklogTaskSubtask(data: taskSubtaskMaster) {
    this.worklogDrawerTitle = "Worklog > " + data.NAME;
    this.taskSubtaskDrawerData = Object.assign({}, data);
    this.type = 4;

    this.worklogDrawerVisible = true;
    this.WorklogComponentVar.getWorklogIDWise(this.type, data.ID);
  }

  commentDrawerClose() {
    this.commentDrawerVisible = false;
    this.getAllTaskSubtask();
  }

  get callBackCommentDrawerClose() {
    return this.commentDrawerClose.bind(this);
  }

  @ViewChild(CommentComponent) CommentComponentVar: CommentComponent;
  typeForComment: number;
  typeIDForComment: number;

  commentTaskSubtask(data: taskSubtaskMaster) {
    this.commentDrawerTitle = "Task/ Subtask Details";
    this.taskSubtaskDrawerData = Object.assign({}, data);
    this.commentDrawerVisible = true;
    this.type = 4;

    this.typeForComment = this.type;
    this.typeIDForComment = data.ID;

    this.CommentComponentVar.loadAllSubtasks(data.ID);
    this.CommentComponentVar.loadAllParentTasks(data.PARENT_ID);

    this.CommentComponentVar.showTags(data.TAGS);
    this.CommentComponentVar.getAttachmentIDWise(this.type, data.ID);
    this.CommentComponentVar.getCommentIDWise(this.type, data.ID);
    this.CommentComponentVar.getWorklogIDWise(this.type, data.ID);
    this.CommentComponentVar.getAssignees(data["TASK_ASSIGNEE_NAMES"]);
    this.CommentComponentVar.getReporterFromID(data["TASK_REPORTER_IDS"]);
  }

  taskTransferHistoryDrawerClose() {
    this.taskTransferHistoryDrawerVisible = false;
  }

  get callBackTaskTransferHistoryDrawerClose() {
    return this.taskTransferHistoryDrawerClose.bind(this);
  }

  taskTransferHistoryTaskSubtask(data: taskSubtaskMaster) {
    this.taskTransferHistoryDrawerTitle = "Task Transfer > " + data.NAME;
    this.taskSubtaskDrawerData = Object.assign({}, data);
    this.taskTransferHistoryDrawerVisible = true;
  }

  attachmentDrawerClose() {
    this.attachmentDrawerVisible = false;
  }

  get callBackAttachmentDrawerClose() {
    return this.attachmentDrawerClose.bind(this);
  }

  @ViewChild(AttachmentMasterComponent)
  AttachmentMasterComponentVar: AttachmentMasterComponent;

  attachmentTaskSubtask(data: taskSubtaskMaster) {
    this.attachmentDrawerTitle = "Attachment > " + data.NAME;
    this.taskSubtaskDrawerData = Object.assign({}, data);
    this.attachmentDrawerVisible = true;
    this.type = 4;

    this.AttachmentMasterComponentVar.getAttachmentIDWise(this.type, data.ID);
  }

  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find((item) => item.value !== null);
    const sortField = (currentSort && currentSort.key) || "id";
    const sortOrder = (currentSort && currentSort.value) || "desc";

    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllTaskSubtask();
  }

  onEnterKeyDown() {
    document.getElementById("button1").focus();
    this.getAllTaskSubtask(true);
  }
}
